export default __webpack_public_path__ + "static/media/team-management-pathway.7eb882cf.svg";